import Swiper from 'swiper/bundle';

(function ($) {

    //swiper
    let swiper = new Swiper(".section-slider-with-products .slider-blocks", {
        slidesPerView: 'auto',
        navigation: {
            nextEl: ".section-slider-with-products .swiper-button-next",
            prevEl: ".section-slider-with-products .swiper-button-prev",
        },
        pagination: {
            el: ".section-slider-with-products .swiper-pagination",
            clickable: true,
        }
    });
})(jQuery);